// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LE-z","hovered":"ME-z","hoverImage":"NE-z","mainImage":"OE-z","imageNoBackground":"PE-z","fullSizeImage":"QE-z"};